import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import moment from 'moment';
import { parse } from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { API_GET_COMPARISON, API_GET_COMPARISON_FILE, apiGetComparison, apiGetComparisonFile, } from '../../../actions/ComparisonActions';
import { propArrayShape, propBool, propFunc, } from '../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../helpers/fetch';
import { safeJsonParse } from '../../../helpers/query';
import CustomRedirect from '../../../route/CustomRedirect';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import ComparisonHeader from './ComparisonHeader';
import ComparisonSections from './ComparisonSections';
class Comparison extends Component {
    constructor(props) {
        super(props);
        this.download = () => {
            const { ids } = this.state;
            const { downloadComparison } = this.props;
            if (ids.length > 1) {
                downloadComparison(ids);
            }
        };
        const parseQuery = parse(window.location.search);
        this.state = {
            ids: safeJsonParse(parseQuery.checks),
            isLoaded: false,
        };
    }
    componentDidMount() {
        const { ids } = this.state;
        const { getComparison } = this.props;
        if (ids.length > 1) {
            getComparison(ids, () => {
                this.setState({ isLoaded: true });
            });
        }
    }
    render() {
        const { isDownloading, isLoading, items } = this.props;
        const { ids, isLoaded } = this.state;
        if (ids.length < 2 || (isLoaded && items.length < 2)) {
            return _jsx(CustomRedirect, { to: '/mypage' });
        }
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main' }, { children: [_jsx("div", Object.assign({ className: 'l-container l-contents' }, { children: _jsx(ComparisonHeader, { isDownloading: isDownloading, isLoading: isLoading, items: items, onClickDownload: this.download }) })), _jsx(ComparisonSections, { isLoading: isLoading, items: items })] })));
    }
}
Comparison.propTypes = {
    downloadComparison: propFunc().isRequired,
    getComparison: propFunc().isRequired,
    isDownloading: propBool().isRequired,
    isLoading: propBool().isRequired,
    items: propArrayShape().isRequired,
};
const mapStateToProps = ({ comparison, fetch }) => ({
    isDownloading: isLoadingApis(fetch, API_GET_COMPARISON_FILE),
    isLoading: isLoadingApis(fetch, API_GET_COMPARISON),
    items: comparison.items || [],
});
const mapDispatchToProps = (dispatch) => ({
    downloadComparison: (ids) => dispatch(apiGetComparisonFile(ids, `プロジェクト事例比較結果_${moment().format('YMD_Hms')}.xlsx`)),
    getComparison: (ids, resolve) => dispatch(apiGetComparison(ids, { resolve })),
});
const enhance = compose(AuthenticationHoc({ isClient: true }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(Comparison);
